@import '../../../constants/spacing.module.less';

.order-sidebar-section {
  border-color: var(--grey-300);
}

.orders-sidebar-section-header {
  border: none;
  gap: @space-8;
  padding: @space-16;
  background: var(--light--header--background-color--1);
}

.orders-sidebar-section-header-content {
  padding: @space-0;
  gap: @space-8;
  align-items: center;
}

.order-sidebar-section-grabber-icon {
  fill: var(--gray-637381);
  height: 18px;
  width: 18px;
  padding: 3px 6px 3px 7px; // figma icon padding
  transform: none;
}

.order-sidebar-section-caret {
  height: 24px;
  width: 24px;
  margin: @space-0;
}

.orders-sidebar-section-header-title-and-count {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.order-sidebar-section-default-padding {
  padding: @space-0 @space-16 @space-24 @space-16;
}
